import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { RadioLangGroup } from 'components/_common/RadioLangGroup';
import { mobileStyles } from './MobileSettings.styles';

interface MobileLanguageProps {
  userSettings: any;
  updatedSettings: any;
  handleChangeLang: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const MobileLanguage: React.FC<MobileLanguageProps> = ({
  userSettings,
  updatedSettings,
  handleChangeLang,
}) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ ...mobileStyles.section, ...mobileStyles.rightPartSection }}>
      <Box sx={mobileStyles.sectionTitleWrapper}>
        <Typography variant="h3" sx={mobileStyles.sectionTitle}>
          {t('settings.lang')}
        </Typography>
      </Box>
      <Box sx={mobileStyles.sectionList}>
        <RadioLangGroup
          onChange={handleChangeLang}
          value={
            updatedSettings && updatedSettings.hasOwnProperty('portalLanguage')
              ? updatedSettings.portalLanguage
              : userSettings.data?.portalLanguage
          }
          data={[
            {
              flagIcon: 'US',
              flagName: 'English (USA)',
              value: 'en-US',
              disabled: true,
            },
          ]}
        />
      </Box>
    </Box>
  );
};

export default MobileLanguage;
